/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import BaseCom from "./BaseCom";
import Icon from "./Icon";
import L from "./Lang";

export const ProcessingModalGlobal = {
    show: () => { },
    hide: () => { }
};

export class ProcessingModal extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
        ProcessingModalGlobal.show = this.show;
        ProcessingModalGlobal.hide = this.hide;
    }

    show = () => {
        this.setState({ show: true });
    }

    hide = () => {
        this.setState({ show: false });
    }

    render() {
        return <Modal show={this.state.show}>
            <Modal.Header>
                <Modal.Title><L>Processing</L></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center fs-1">
                    <Icon icon="faSpinner" spin />
                </div>
            </Modal.Body>
        </Modal>
    }
}